import { render, staticRenderFns } from "./ptStrategyRate.vue?vue&type=template&id=51851636&scoped=true"
import script from "./ptStrategyRate.vue?vue&type=script&lang=js"
export * from "./ptStrategyRate.vue?vue&type=script&lang=js"
import style0 from "./ptStrategyRate.vue?vue&type=style&index=0&id=51851636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51851636",
  null
  
)

export default component.exports